import React, { type FunctionComponent, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import FilterBar from 'legacy/components/FilterBar'
import { Button } from 'gin-and-tonic/common/button/Button'
import { Input } from 'gin-and-tonic/common/input/Input'

interface Props {
  initialOrderId?: string
  onSubmit: (orderId: string) => void
}

export const OrderFilters: FunctionComponent<Props> = ({ initialOrderId, onSubmit }) => {
  const [orderId, setOrderId] = useState<string>(initialOrderId)

  return (
    <FilterBar padding="15px 20px">
      <div style={{ display: 'flex', width: '380px' }}>
        <Input
          placeholder="Order ID"
          name="Order ID"
          value={orderId}
          onKeyDown={e => {
            if (e.key == 'Enter') onSubmit(orderId)
          }}
          onChange={e => setOrderId(e.target.value)}
        />
      </div>
      <Button onClick={_ => onSubmit(orderId)}>
        <FormattedMessage id="connect.fulfillmentSimulator.loadOrder" />
      </Button>
    </FilterBar>
  )
}
